import { render } from "./javascript-chapter-2.vue?vue&type=template&id=92d6b9b0"
import script from "./javascript-chapter-2.vue?vue&type=script&lang=js"
export * from "./javascript-chapter-2.vue?vue&type=script&lang=js"

import "./javascript-chapter-2.vue?vue&type=style&index=0&id=92d6b9b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__